import React, { Component } from "react";
import { withControlPoints } from "../../../shared/containers/containerControlPoints";
import { states } from "../../../reducers/queriesStates";
import styles from "./controlPointsMap.module.scss";
import L from "leaflet";
import { MapContainer, MapConsumer, TileLayer, Marker, Popup } from "react-leaflet";
import { withMapControl } from "../../../shared/containers/containerMapControl";

import TopRightMapControl from "../../LayerMapCotrol/TopRightMapControl";
import TopLefttMapControl from "../../LayerMapCotrol/TopLeftMapControl";
import BaseLayerMapControl from "../../LayerMapCotrol/BaseLayerMapControl";
import { withAppState } from "../../../shared/containers/containerAppState";
import ControlPointMarkers from "./ControlPointMarkers";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import ControlPointTool from "../../LayerMapCotrol/ControlPointTool";
import ControlPointInfo from "../../LayerMapCotrol/ControlPointInfo";

class ControlPointsMap extends Component {
  constructor(props) {
    super(props);

    this.state = { mapBounds: null };
  }

  componentDidMount() {
    const { controlPointsDataState, onGetControlPoints } = this.props;

    if (controlPointsDataState === states.NOT_REQUESTED) {
      onGetControlPoints();
    }
  }

  componentDidUpdate(prevProps) {
    const { controlPointsDataState, controlPoints, selectedControlPointId, selectedRouteId } = this.props;

    if (controlPointsDataState === states.READY && prevProps.controlPointsDataState === states.REQUEST) {
      const bounds = [
        controlPoints.map((x) => {
          return [x.latitude, x.longitude];
        }),
      ];

      if (controlPoints.length > 0) {
        this.setState({ mapBounds: L.latLngBounds(bounds) });
      }
    }

    if (selectedRouteId !== null && selectedRouteId !== prevProps.selectedRouteId) {
      const latLngs = controlPoints
        .filter((f) => {
          return f.routes.some((s) => {
            return s.id === selectedRouteId;
          });
        })
        .map((x) => {
          return [x.latitude, x.longitude];
        });

      if (latLngs.length > 0) {
        this.setState({ mapBounds: L.latLngBounds([latLngs]) });
      }
    }

    if (selectedControlPointId !== null && selectedControlPointId !== prevProps.selectedControlPointId) {
      this.setState({ mapBounds: null });
    }
  }

  getChildrens() {
    const { mapBaseLayer } = this.props;

    return (
      <div>
        {mapBaseLayer.url.map((_url, index) => {
          return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
        })}

        <ControlPointMarkers />
      </div>
    );
  }

  render() {
    const { mapBaseLayer, zoom, mapCenter, isSideBarOpen, selectedRouteId } = this.props;
    const { mapBounds } = this.state;

    return (
      <div className={styles.controlPointsMapContainer}>
        <MapContainer
          style={{ height: "100%" }}
          key={`${mapBaseLayer.name} ${zoom} ${mapCenter.lat} ${mapCenter.lng} ${isSideBarOpen} ${selectedRouteId}`}
          crs={mapBaseLayer.crs}
          center={mapCenter}
          zoom={zoom}
          maxZoom={mapBaseLayer.maxZoom}
          minZoom={3}
          zoomControl={true}
          attributionControl={false}
          doubleClickZoom={false}
          scrollWheelZoom={true}
          dragging={true}
          animate={true}
          easeLinearity={0.35}
          className={styles.mapMainWrapper}
        >
          <MapConsumer>
            {(map) => {
              if (mapBounds !== null) {
                map.fitBounds(mapBounds.pad(1));
              }

              return null;
            }}
          </MapConsumer>

          {this.getChildrens()}
          <ControlPointTool />
        </MapContainer>

        <TopRightMapControl>
          <BaseLayerMapControl />
        </TopRightMapControl>

        <TopLefttMapControl>
          <ControlPointInfo />
        </TopLefttMapControl>
      </div>
    );
  }
}

export default withRoutes(withAppState(withMapControl(withControlPoints(React.memo(ControlPointsMap)))));
